import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { FeatureService } from '../../../core/services/permission/feature.service';
import { PermissionService } from '../../../core/services/permission/permission.service';
import { TriallerService } from '../../../core/services/trialler.service';
/** Import Data Model Types */
import { Params } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { RouterStateService } from '../../../core/routing/router-state.service';
import { EstimateTemplateAvailabilityScope } from '../../estimates/models';

@UntilDestroy()
@Component({
    selector: 'menubar-estimates',
    templateUrl: './menubar.estimates.component.html',
    styleUrls: ['./menubar.estimates.component.scss'],
    standalone: false,
})
export class MenubarEstimatesComponent {
    @Input() estimate: any;
    // @ts-ignore TS2564
    @Input() active: boolean;
    @Input() readonly = false;

    @Output() itemClick = new EventEmitter();

    currentRouteUrl: string = '';

    EstimateTemplateAvailabilityScope = EstimateTemplateAvailabilityScope;
    showNavigationFlow = false;

    constructor(
        public permissionService: PermissionService,
        public featureService: FeatureService,
        private triallerService: TriallerService,
        private routerStateService: RouterStateService
    ) {
        this.showNavigationFlow = this.triallerService.isTrialler() || this.triallerService.isNewAccount();
        this.routerStateService.routeChanged$.pipe(untilDestroyed(this)).subscribe(() => {
            this.currentRouteUrl = this.routerStateService.getCurrentUrlRoute();
        });
    }

    onChangeRoute($event: MouseEvent, route: string[], params?: Params) {
        $event.preventDefault();
        this.itemClick.emit({ $event, route, params });
    }
}

@NgModule({
    declarations: [MenubarEstimatesComponent],
    imports: [CommonModule],
    exports: [MenubarEstimatesComponent],
})
export class MenubarEstimatesModule {}
